

/// <reference path="StockNote.ts" />

// Generated class InternalInputNote_ManagedObject

class InternalInputNote_ManagedObject extends StockNote
{
}
